import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import * as PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { removeErrorMessage } from "slices/app/errorSlice";

const ConfirmationModal = ({
  headerText,
  bodyText,
  okButton,
  cancelButton,
  onClose,
}) => {
  const confError = useSelector((state) => state.error.errorMessage);
  const dispatch = useDispatch();

  const handleOk = () => {
    dispatch(removeErrorMessage);
    okButton.onOk();
  };

  const handleCancel = () => {
    dispatch(removeErrorMessage);
    dispatch(hideModal(modalTypes.CONFIRMATION));
    cancelButton?.onCancel?.();
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      data-testid="confirmation-modal"
      className="fade-in"
      show
      onDismiss={onClose != null ? handleCancel : undefined}
      backdrop
      centered
    >
      <Modal.Header>
        <b>{headerText}</b>
      </Modal.Header>
      <Modal.Body style={{ whiteSpace: "break-spaces" }}>
        {bodyText || confError}
      </Modal.Body>
      <Modal.Footer>
        {cancelButton ? (
          <NewButton
            data-testid="cancel-button"
            variant={NewButtonVariant.l2}
            onClick={handleCancel}
          >
            {cancelButton.text}
          </NewButton>
        ) : null}
        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={handleOk}
        >
          {okButton?.text}
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.node.isRequired,
  okButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired,
  }).isRequired,
  cancelButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
  }),
  onClose: PropTypes.func,
};
